import { AlertImage } from './alert-image.model'
import AlertMessageOptions from '@/interfaces/alert-message-options'

export const alertMessageOptionsOtherCaseError: AlertMessageOptions = {
  classNameHeader: 'alert-other-cases-error',
  image: AlertImage.ALERT_INFO_ICON,
  message: 'ขออภัย เกิดข้อผิดพลาดในระบบ (500)<br>เรากำลังแก้ปัญหา และจะกลับมาใช้งานได้เร็ว ๆ นี้'
}

export const alertMessageError = (code: number) => ({
  classNameHeader: 'alert-other-cases-error',
  image: AlertImage.ALERT_INFO_ICON,
  message: `ขออภัย เกิดข้อผิดพลาดในระบบ (${code})<br>เรากำลังแก้ปัญหา และจะกลับมาใช้งานได้เร็ว ๆ นี้`
}) as AlertMessageOptions

export const alertMessageOptionsSomethingWentWrong: AlertMessageOptions = {
  classNameHeader: 'alert-something-went-wrong',
  image: AlertImage.ALERT_INFO_ICON,
  message: 'มีบางอย่างผิดพลาด กรุณาลองอีกครั้ง',
}
